import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// --- PASTE YOUR FIREBASE CONFIGURATION OBJECT HERE ---
const firebaseConfig = {
  apiKey: "AIzaSyCUsSWEQQtxawDPJzUKpwP3wKchE-9rwyA",
  authDomain: "mbbscompanion-internportal.firebaseapp.com",
  projectId: "mbbscompanion-internportal",
  storageBucket: "mbbscompanion-internportal.firebasestorage.app",
  messagingSenderId: "396731432941",
  appId: "1:396731432941:web:464ae784843b56767cb1e4",
  measurementId: "G-G5DKEBX5E5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, app };
